module.exports = __webpack_public_path__ + "img/il.7b8aeb98.svg";